import { GeneratorElutionDto, CreateGeneratorElutionDto } from '@services/dtos'
import { baseCrudReducer } from './baseCrudReducer'
import { generatorElutionService, GeneratorElutionsFilters } from '@services/generatorElutionService'
import { createAsyncThunk } from '@reduxjs/toolkit'

const getCurrentActivities = createAsyncThunk<Record<string, number | null>, string[]>(
  'generatorElution/getCurrentActivities',
  (ids) => generatorElutionService.getCurrentActivities(ids)
)

const { reducer, actions, thunks } = baseCrudReducer<
  GeneratorElutionDto,
  CreateGeneratorElutionDto,
  {},
  GeneratorElutionsFilters
>('generatorElution', generatorElutionService, {
  extraReducers: (builder) => {
    builder.addCase(getCurrentActivities.fulfilled, (state, action) => {
      for (const [id, activityAtTimeMbq] of Object.entries(action.payload)) {
        const item = state.items.datas.find((elution) => elution.id === id)
        if (item) {
          item.activityAtTimeMbq = activityAtTimeMbq
        }
      }
    })
  }
})

export default reducer

export const { setFilters: setGeneratorElutionFilters } = actions

export const {
  getAll: getGeneratorElutions,
  create: createGeneratorElution,
  update: updateGeneratorElution,
  remove: removeGeneratorElution,
} = thunks

export { getCurrentActivities as getGeneratorElutionCurrentActivities }
